import { Injectable } from '@angular/core';
import { MenuPositionX, MenuPositionY } from '@angular/material/menu';

@Injectable({
  providedIn: 'root',
})
export class InlineMenuPositionService {
  public calculateMenuPosition(triggerElem: HTMLElement): { xPosition: MenuPositionX; yPosition: MenuPositionY } {
    const rect: DOMRect = triggerElem.getBoundingClientRect();
    const halfPageHeight: number = window.innerHeight / 2;
    const halfPageWidth: number = window.innerWidth / 2;

    const yPosition: MenuPositionY = rect.top > halfPageHeight ? 'above' : 'below';
    const xPosition: MenuPositionX = rect.left > halfPageWidth ? 'before' : 'after';

    return { xPosition, yPosition };
  }
}
